import { render, staticRenderFns } from "./ScreenEncuestas.vue?vue&type=template&id=552774da"
import script from "./ScreenEncuestas.vue?vue&type=script&lang=js"
export * from "./ScreenEncuestas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports